"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AuthorizationProvider_1 = require("../providers/AuthorizationProvider");
var CacheProvider_1 = require("../providers/CacheProvider");
var ConfigProvider_1 = require("../providers/ConfigProvider");
var either_1 = require("../utils/either");
var promise_1 = require("../utils/promise");
var useBoolean_1 = __importDefault(require("./useBoolean"));
var useToken_1 = __importDefault(require("./useToken"));
var useCiselnik = function (ciselnik) {
    var cache = CacheProvider_1.useCache();
    var authorization = AuthorizationProvider_1.useAuthorization();
    var _a = ConfigProvider_1.useConfig(), ciselnikyUrl = _a.ciselnikyUrl, zadostiCiselnikyUrl = _a.zadostiCiselnikyUrl, disableAuth = _a.disableAuth;
    var adminUrl = ConfigProvider_1.useConfig().adminUrl;
    var zasobnikCiselnikyUrl = ConfigProvider_1.useConfig().zasobnikCiselnikyUrl;
    var _b = ConfigProvider_1.useConfig(), pomuckyCiselnikykUrl = _b.pomuckyCiselnikykUrl, pojisteniCiselnikyUrl = _b.pojisteniCiselnikyUrl, posudkyCiselnikyUrl = _b.posudkyCiselnikyUrl, ukonyCiselnikyUrl = _b.ukonyCiselnikyUrl;
    var isLoading = useBoolean_1.default(true);
    var _c = react_1.useState(), error = _c[0], setError = _c[1];
    var _d = react_1.useState(), data = _d[0], setData = _d[1];
    var token = useToken_1.default();
    // TODO: solve any
    var urls = {
        druhyOsob: ciselnikyUrl + "/DruhyOsob",
        posudkyDruhyOsob: posudkyCiselnikyUrl + "/DruhyOsoby",
        posudkyRole: posudkyCiselnikyUrl + "/Role",
        soudniKraje: ciselnikyUrl + "/SoudniKraje",
        soudniOkresy: ciselnikyUrl + "/SoudniOkresy",
        soudniObec: ciselnikyUrl + "/SoudniObec",
        specializace: ciselnikyUrl + "/Specializace",
        specializaceVcetneNeplatnych: ciselnikyUrl + "/Specializace?VcetneNeplatnych=true",
        typyAdres: ciselnikyUrl + "/TypyAdres",
        jazyky: (cache === null || cache === void 0 ? void 0 : cache.read('appConfig').TLUMOCNICI_CISELNIKY) + "Jazyky",
        jazykyVcetneNeplatnych: ciselnikyUrl + "/Jazyky?VcetneNeplatnych=true",
        jazykSpecializace: ciselnikyUrl + "/Specializace",
        typySkutecnosti: ciselnikyUrl + "/TypySkutecnosti",
        typyZaniku: ciselnikyUrl + "/TypyZaniku",
        typyPozastaveni: ciselnikyUrl + "/TypyPozastaveni",
        typyPrestupku: ciselnikyUrl + "/TypyPrestupku",
        typyOdmitnuti: ciselnikyUrl + "/TypyOdmitnuti",
        formyUkonu: ukonyCiselnikyUrl + "/FormyUkonu",
        formyOdposlechu: ukonyCiselnikyUrl + "/FormyOdposlechu",
        typyExternichSubjektu: ciselnikyUrl + "/TypyExternichSubjektu",
        role: adminUrl + "/Role",
        mandaty: adminUrl + "/Mandaty",
        kategorieUdalosti: zasobnikCiselnikyUrl + "/KategorieUdalosti",
        typyUdalosti: zasobnikCiselnikyUrl + "/TypyUdalosti",
        druhyUdalosti: zasobnikCiselnikyUrl + "/DruhyUdalosti",
        typyPomucek: pomuckyCiselnikykUrl + "/TypyPomucky",
        druhyDokladu: pojisteniCiselnikyUrl + "/DruhyDokladu",
        stavyPojisteni: pojisteniCiselnikyUrl + "/StavySchvaleni",
        typyOdmeny: posudkyCiselnikyUrl + "/TypyOdmeny",
        ukonyRole: ukonyCiselnikyUrl + "/Role",
        ukonyDruhyOsob: ukonyCiselnikyUrl + "/DruhyOsoby",
        ukonyTypyOdmeny: ukonyCiselnikyUrl + "/TypyOdmeny",
        typyZadostiSeznam: zadostiCiselnikyUrl + "/TypyZadostiSeznam",
        typyZadostiEvidence: zadostiCiselnikyUrl + "/TypyZadostiEvidence",
        posudkyStornoDuvody: posudkyCiselnikyUrl + "/StornoDuvody",
        ukonyStornoDuvody: ukonyCiselnikyUrl + "/StornoDuvody",
        sazbaDph: posudkyCiselnikyUrl + "/SazbyDph",
    };
    react_1.useEffect(function () {
        if (cache && !isLoading.value) {
            cache.write(urls[ciselnik], data);
        }
    }, [data, isLoading.value]);
    react_1.useEffect(function () {
        var fetch = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url, cacheHit, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isLoading.setTrue();
                        url = urls[ciselnik];
                        cacheHit = cache === null || cache === void 0 ? void 0 : cache.read(url);
                        if (!disableAuth && (authorization === null || authorization === void 0 ? void 0 : authorization.value) && ((_a = token === null || token === void 0 ? void 0 : token.getDataFromToken(authorization.value)) === null || _a === void 0 ? void 0 : _a.exp) * 1000 < new Date().getTime()) {
                            token.logout();
                            return [2 /*return*/, either_1.Left({ status: '401', message: 'Uživatel nemá oprávnění na danou akci' })];
                        }
                        if (cacheHit) {
                            setData(cacheHit);
                            return [2 /*return*/, isLoading.setFalse()];
                        }
                        return [4 /*yield*/, promise_1.getJSON(url, __assign({}, ((authorization === null || authorization === void 0 ? void 0 : authorization.value) && { Authorization: authorization.value })))];
                    case 1:
                        result = _b.sent();
                        if (either_1.isLeft(result)) {
                            setError(result.value.message);
                            return [2 /*return*/, isLoading.setFalse()];
                        }
                        setData(result.value);
                        isLoading.setFalse();
                        return [2 /*return*/];
                }
            });
        }); };
        fetch();
    }, []);
    return { loading: isLoading.value, error: error, data: data };
};
exports.default = useCiselnik;
